/* ============================================
   CART UPSELL BFE - TDTP
   ============================================

   Twee taken:

   1. Verversen na een cartwijziging. Pipeline ververst alleen [data-line-items];
      de upsell valt daarbuiten. Alle condities zijn cart-afhankelijk (verberg wat
      al in de cart zit, toon op basis van wat er in de cart zit), dus zonder dit
      klopte de lijst pas na een volledige paginalading.

   2. Vastzetten boven het checkout-blok. Dat is een DOM-verplaatsing, geen
      flex-order: Pipeline doet hetzelfde met zijn eigen page-upsell, en een
      A/B-variant kan een verplaatst element wél betrouwbaar aansturen.

   Versie: 1.0 - 28-07-2026
   ============================================ */

(function () {
  'use strict';

  var SECTION = 'api-cart-upsell';
  var slots = { drawer: '[data-cart-upsell-slot="drawer"]', panel: '[data-cart-upsell-slot="panel"]' };
  var reloading = false;

  function rootUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
  }

  function pinIfNeeded() {
    var host = document.querySelector(slots.drawer);
    if (!host) return;
    var block = host.querySelector('[data-cart-upsell]');
    if (!block || host.dataset.pinned !== 'true') return;

    var bottom = document.querySelector('#drawer-cart [data-cart-bottom]');
    var checkoutBox = bottom && bottom.querySelector('.cart-checkout-box-bfe');
    if (!bottom || !checkoutBox) return;

    // Alleen verplaatsen als hij er nog niet staat, anders vecht dit met een
    // herrender en springt het blok bij elke cartwijziging.
    if (block.parentNode === bottom) return;
    bottom.insertBefore(block, checkoutBox);
    // In de drawer staat er 30px marge boven om het van de cart-items te
    // scheiden. Boven het checkout-blok is die ruimte er al en levert het
    // alleen een gat op.
    block.classList.add('cart-upsell-bfe--pinned');

    if (window.Alpine && typeof window.Alpine.initTree === 'function') {
      // Alpine verliest de binding bij verplaatsen; opnieuw initialiseren zodat
      // de quickview-knop blijft werken.
      window.Alpine.initTree(block);
    }
  }

  // De api-sectie levert alleen <li>-kaarten: een sectie kan de instellingen van
  // cart-drawer niet lezen, dus layout, kop en maximum blijven in de bestaande
  // wrapper staan en alleen de lijst wordt ververst.
  function swap(items, key) {
    var host = document.querySelector(slots[key]);
    if (!host) return;
    var block = host.querySelector('[data-cart-upsell]');
    var list = block && block.querySelector('.cart-upsell-bfe__list');
    if (!block || !list) return;

    var max = parseInt(block.getAttribute('data-max-items'), 10);
    if (!max || max < 1) max = 6;

    list.innerHTML = '';
    var count = 0;
    for (var i = 0; i < items.length && count < max; i++) {
      list.appendChild(items[i].cloneNode(true));
      count++;
    }

    // Niets meer over? Dan het hele blok verbergen in plaats van een lege lijst.
    block.hidden = count === 0;

    if (window.Alpine && typeof window.Alpine.initTree === 'function') {
      window.Alpine.initTree(list);
    }
  }

  function reload() {
    if (reloading) return;
    if (!document.querySelector(slots.drawer) && !document.querySelector(slots.panel)) return;
    reloading = true;

    fetch(rootUrl() + '?section_id=' + SECTION)
      .then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var fresh = document.createElement('div');
        fresh.innerHTML = html;
        var items = fresh.querySelectorAll('.cart-upsell-bfe__item');
        swap(items, 'drawer');
        swap(items, 'panel');
        pinIfNeeded();
      })
      .catch(function (e) {
        // Stil falen: een niet-ververste upsell is hinderlijk, een kapotte cart
        // is erger. De oude lijst blijft dan gewoon staan.
        if (window.console) console.warn('[cart-upsell-bfe] verversen mislukt:', e);
      })
      .finally(function () {
        reloading = false;
      });
  }

  document.addEventListener('theme:cart:change', reload);
  document.addEventListener('theme:cart:reload', reload);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pinIfNeeded);
  } else {
    pinIfNeeded();
  }
})();
